import { ErrorResponse, UserRequestDto } from '@gtpl/shared-models/common-models';
import { AllItemSubCategoryResponse, CommonResponse, ItemSubCategoriesDropDownResponse, ItemSubCategoryResponse } from '@gtpl/shared-models/masters';
import { LogsService } from '@gtpl/shared-services/user-logs';
import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import appSettings from 'apps/services/config';
import { Console } from 'console';
import { ItemSubCategoryDropDownDto } from 'libs/shared-models/masters/src/lib/item-sub-categories/item-sub-categories-drop-down.dto';
import { LogsDto } from 'libs/shared-models/user-logs/src/lib/Logs/logs.dto';
import { getManager, Repository } from 'typeorm';
import { ItemCategoryRequest, ItemsubcategoryforSonumber } from '../item-categories/dto/item-categories.request';
import { ItemSubCategoryAdapter } from './dto/item-sub-category.adapter';
import { ItemSubCategoryDto } from './dto/item-sub-category.dto';
import { ItemSubCategoryRequest } from './dto/item-sub-category.request';
import { ItemSubCategory } from './item-sub-category.entity';

@Injectable()
export class ItemSubCategoriesService {
    constructor(
        private logService: LogsService,
        @InjectRepository(ItemSubCategory) private ItemSubCategoryRepository: Repository<ItemSubCategory>,
        private itemSubcategoryAdapter: ItemSubCategoryAdapter,
    ) { }

    async createItemSubCategory(itemCatDto: ItemSubCategoryDto, isUpdate: boolean, request: Request): Promise<ItemSubCategoryResponse> {
        try {
            let previousValue
            if (!isUpdate) {
                const itemSubCatEntity = await this.getItemSubCategory(itemCatDto.itemSubCategory);
                if (itemSubCatEntity) {
                    throw new ItemSubCategoryResponse(false, 11104, 'Item category already exists');
                }
            }
            else {
                const previous = await this.ItemSubCategoryRepository.findOne({where:{itemSubCategoryId:itemCatDto.itemSubCategoryId}})
                previousValue = previous.itemSubCategory
                const itemSubCatEntity = await this.getItemSubCategory(itemCatDto.itemSubCategory);
                if (itemSubCatEntity) {
                    if (itemSubCatEntity.itemSubCategoryId != itemCatDto.itemSubCategoryId) {
                        throw new ItemSubCategoryResponse(false, 11104, 'Item category already exists');
                    }
                }
            }
            const convertedItemSubCatEntity: ItemSubCategory = this.itemSubcategoryAdapter.convertDtoToEntity(itemCatDto, isUpdate);
            const savedItemSubCatEntity: ItemSubCategory = await this.ItemSubCategoryRepository.save(convertedItemSubCatEntity);
            const savedItemCatDto: ItemSubCategoryDto = this.itemSubcategoryAdapter.convertEntityToDto(savedItemSubCatEntity);

            if (savedItemCatDto) {
                const presentValue = savedItemCatDto.itemSubCategory
                const response = new ItemSubCategoryResponse(true, isUpdate ? 11100 : 11101, isUpdate ? 'Item sub category Updated Successfully' : 'Item sub category Created Successfully', savedItemCatDto);
                // const name = isUpdate ? 'updated' : 'created'
                // const newLogDto = new LogsDto(1, name, 'ItemSubCategory', savedItemCatDto.itemSubCategoryId, true, '', "")
                // let res = await this.logService.createLog(newLogDto);
                // console.log(res);
                const name =isUpdate ? 'update':'create'
                const userName = isUpdate ? savedItemCatDto.updatedUser : savedItemCatDto.createdUser
                const displayValue = isUpdate? 'Item sub category Updated Successfully': 'Item sub category Created Successfully'
               const newLogDto = new LogsDto(1,name, 'ItemSubCategory', savedItemCatDto.itemSubCategoryId, true, displayValue,userName,previousValue,presentValue)
               let res = await this.logService.createLog(newLogDto);
                return response;
            } else {
                throw new ItemSubCategoryResponse(false, 11106, 'Item sub category saved but issue while transforming into DTO');
            }
        }
        catch (error) {
            return error;
        }
    }

    /**
    * gets all   Item categories details  
    * @returns all the  Item category details .
    */
    // @LogActions({ isAsync: true })
    async getAllItemSubCategories(req?:UserRequestDto): Promise<AllItemSubCategoryResponse> {
        try {
            const iteCatDto: ItemSubCategoryDto[] = [];
            // retrieves all plants
            const itemCatEntities: ItemSubCategory[] = await this.ItemSubCategoryRepository.find({
                order: { itemSubCategory: "ASC" },
                relations: ['itemCategory', 'itemInfo']
            });
            //   console.log(itemCatEntities);
            if (itemCatEntities.length > 0) {
                itemCatEntities.forEach(itemcatEntity => {
                    const convertedItemcatDto: ItemSubCategoryDto = this.itemSubcategoryAdapter.convertEntityToDto(itemcatEntity);
                    iteCatDto.push(convertedItemcatDto);
                });
                console.log(iteCatDto);
                const response = new AllItemSubCategoryResponse(true, 11208, "Item sub categories retrieved successfully", iteCatDto);
                if(req?.createdUser){
                    const newLogDto = new LogsDto(1, 'view', 'ItemSubCategory', 0, true, 'Item sub categories retrieved successfully', req.createdUser)
                    let res = await this.logService.createLog(newLogDto);
                    console.log(res);
                }

                return response;
            } else {
                //   console.log('yest')
                throw new ItemSubCategoryResponse(false, 99998, 'No Records Found');
            }
        } catch (err) {
            return err;
        }
    }


    /**
   * gets all item sub category details  
   * @returns all item sub category details .
   */
    async getAllItemSubCategoriesDropDown(): Promise<ItemSubCategoriesDropDownResponse> {
        try {
            const itemSubcategoryDTO: ItemSubCategoryDropDownDto[] = [];
            const itemSubCategoryEntities: ItemSubCategory[] = await this.ItemSubCategoryRepository.find({ select: ['itemSubCategoryId', 'itemSubCategory', 'itemSubCategoryCode'], where: { isActive: true }, order: { itemSubCategory: 'ASC' } });
            if (itemSubCategoryEntities && itemSubCategoryEntities.length > 0) {
                itemSubCategoryEntities.forEach(itemSubCatEntity => {
                    itemSubcategoryDTO.push(new ItemSubCategoryDropDownDto(itemSubCatEntity.itemSubCategoryId, itemSubCatEntity.itemSubCategory, itemSubCatEntity.itemSubCategoryCode));
                });
                const response = new ItemSubCategoriesDropDownResponse(true, 11108, "Item sub categories retrieved successfully", itemSubcategoryDTO);
                return response;
            } else {
                throw new ItemSubCategoryResponse(false, 99998, 'Data not found');
            }
        } catch (err) {
            return err;
        }
    }

    async getItemSubCategory(itemSubCategory: string): Promise<ItemSubCategory> {
        //  console.log(employeeId);
        const response = await this.ItemSubCategoryRepository.findOne({
            where: { itemSubCategory: itemSubCategory },
        });
        // console.log(response);
        if (response) {
            return response;
        } else {
            return null;
        }
    }

    async getItemSubCategoryForBomItem(itemSubCategory: string, category: string): Promise<ItemSubCategory> {
        //  console.log(employeeId);
        const type = (category) ? 'packing' : 'raw';
        itemSubCategory = (itemSubCategory) ? itemSubCategory : 'Raw';
        const response = await this.ItemSubCategoryRepository.findOne({
            where: { itemSubCategory: itemSubCategory, itemSubCategoryCode: type },
        });
        // console.log(response);
        if (response) {
            return response;
        } else {
            return null;
        }
    }

    async getItemSubCategoryForId(itemSubCategoryId: number): Promise<ItemSubCategoryDropDownDto> {
        const response = await this.ItemSubCategoryRepository.findOne({
            select: ['itemSubCategoryId', 'itemSubCategory', 'itemSubCategoryCode'],
            where: { itemSubCategoryId: itemSubCategoryId },
        });
        if (response) {
            return new ItemSubCategoryDropDownDto(response.itemSubCategoryId, response.itemSubCategory, response.itemSubCategoryCode);
        } else {
            return null;
        }
    }


    async getItemSubCategoriesForCategoryDropDown(req: ItemCategoryRequest): Promise<ItemSubCategoriesDropDownResponse> {
        try {
            const itemSubCategoryEntities: ItemSubCategoryDropDownDto[] = await this.ItemSubCategoryRepository
                .createQueryBuilder('item_sub_categories')
                .select('item_sub_category_id as itemSubCategoryId, item_sub_category as itemSubCategory, category_code as itemSubCategoryCode')
                .where(`is_active=1 and item_category_id='${req.itemCategoryId}'`)
                .orderBy('item_sub_category')
                .getRawMany();

            if (itemSubCategoryEntities && itemSubCategoryEntities.length > 0) {
                const response = new ItemSubCategoriesDropDownResponse(true, 11108, "Item sub categories retrieved successfully", itemSubCategoryEntities);
                return response;
            } else {
                throw new ItemSubCategoryResponse(false, 99998, 'Data not found');
            }
        } catch (err) {
            return err;
        }
    }

    async activateOrDeactivateItemSubCategory(itemReq: ItemSubCategoryRequest): Promise<ItemSubCategoryResponse> {
        try {
            const itemSubCatExists = await this.getItemSubCategoryById(itemReq.itemSubCategoryId);
            if (itemSubCatExists) {
                if (itemReq.versionFlag !== itemSubCatExists.versionFlag) {
                    throw new ItemSubCategoryResponse(false, 10113, 'Someone updated the current item category information.Refresh and try again');
                } else {

                    const itemCatSatatus = await this.ItemSubCategoryRepository.update(
                        { itemSubCategoryId: itemReq.itemSubCategoryId },
                        { isActive: itemReq.isActive, updatedUser: itemReq.updatedUser });

                    if (itemSubCatExists.isActive) {
                        if (itemCatSatatus.affected) {
                            const itemcatResponse: ItemSubCategoryResponse = new ItemSubCategoryResponse(true, 10115, 'Item Sub category is de-activated successfully');
                            return itemcatResponse;
                        } else {
                            throw new ItemSubCategoryResponse(false, 10111, 'Item category is already deactivated');
                        }
                    } else {
                        if (itemCatSatatus.affected) {
                            const itemcatResponse: ItemSubCategoryResponse = new ItemSubCategoryResponse(true, 10114, 'Item Sub category is activated successfully');
                            return itemcatResponse;
                        } else {
                            throw new ItemSubCategoryResponse(false, 10112, 'Item Sub category is already  activated');
                        }
                    }
                    // }
                }
            } else {
                throw new ItemSubCategoryResponse(false, 99998, 'No Records Found');
            }
        } catch (err) {
            return err;
        }
    }

    async getItemSubCategoryById(itemSubCategoryId: number): Promise<ItemSubCategory> {
        //  console.log(employeeId);
        const response = await this.ItemSubCategoryRepository.findOne({
            where: { itemSubCategoryId: itemSubCategoryId },
        });
        // console.log(employeeresponse);
        if (response) {
            return response;
        } else {
            return null;
        }
    }

    async getitemsubcategoryforsalorderId(req: ItemsubcategoryforSonumber): Promise<CommonResponse> {
        const manger = getManager();
        try {
            let query;

            if (req.saleOrderId != 0) {
                let mainsoitem = 'SELECT main_so_item_id AS mainsoItem FROM ' + appSettings.sales_db + '.sale_order_items WHERE sale_order_id =' + req.saleOrderId + ''
                const mainsoitemreq = await manger.query(mainsoitem)

                console.log(mainsoitemreq, 'mainsoitemreq')

                let MainjobsaleOrderId = 'SELECT si.sale_order_id AS saleOrderId FROM ' + appSettings.sales_db + '.sale_order_items si LEFT JOIN ' + appSettings.sales_db + '.so_invoice_details sd ON si.sale_order_id=sd.sale_order_id WHERE si.main_so_item_id=' + mainsoitemreq[0].mainsoItem + ' AND job_type="Main Job"'

                const MainjobsaleOrderIdreq = await manger.query(MainjobsaleOrderId)
                console.log(MainjobsaleOrderIdreq, 'MainjobsaleOrderIdreq')

                query = ' SELECT b.item_sub_category_id AS itemSubCategoryId,sale_order_id AS saleOrderId,item_sub_category AS itemSubCategory FROM ' + appSettings.sales_db + '.bom_details b LEFT JOIN ' + appSettings.masters_db + '.item_sub_categories i ON i.item_sub_category_id=b.item_sub_category_id  WHERE b.sale_order_id=' + MainjobsaleOrderIdreq[0].saleOrderId + ' AND b.packing_category IS NOT NULL GROUP BY b.item_sub_category_id';
            }
            else {
                query = ' SELECT item_sub_category_id AS itemSubCategoryId,item_sub_category AS itemSubCategory ,item_category_id FROM `erpx_dev_masters`.`item_sub_categories` '

            }
            const data = await manger.query(query)

            if (data.length > 0) {
                return new CommonResponse(true, 1111, 'Data Retreived sucessfully', data)
            } else {
                return new CommonResponse(true, 1111, 'No data found')
            }

        }
        catch (error) {
            throw error
        }
    }

    async getGeneralItemSubCategories(): Promise<CommonResponse> {
        try {
            const iteCatDto: ItemSubCategoryDto[] = [];
            // retrieves all plants
            const itemCatEntities: ItemSubCategory[] = await this.ItemSubCategoryRepository.find({
                order: { itemSubCategory: "ASC" },
                relations: ['itemCategory', 'itemInfo'],

            });
              console.log(itemCatEntities);
            if (itemCatEntities.length > 0) {
                console.log(itemCatEntities, '------------------enitites')
                itemCatEntities.forEach(itemcatEntity => {
                    if (itemcatEntity.itemCategory.itemCategoryId == 36) {
                        const convertedItemcatDto: ItemSubCategoryDto = this.itemSubcategoryAdapter.convertEntityToDto(itemcatEntity);
                        iteCatDto.push(convertedItemcatDto);
                    }
                });
                console.log(iteCatDto);
                const response = new CommonResponse(true, 11208, "Item sub categories retrieved successfully", iteCatDto);
                return response;
            } else {
                //   console.log('yest')
                throw new CommonResponse(false, 99998, 'No Records Found');
            }
        } catch (err) {
            return err;
        }
    }

}
